export default {
  back: 'Назад',
  tagsTitle: 'Читайте больше по тэгам'
}
